import { addCollection } from '@iconify/react';
import iconSet from './iconSet';

addCollection(iconSet);
